import { render, staticRenderFns } from "./FlowApproveNode.vue?vue&type=template&id=4b1a2c54&scoped=true&"
import script from "./FlowApproveNode.vue?vue&type=script&lang=js&"
export * from "./FlowApproveNode.vue?vue&type=script&lang=js&"
import style0 from "./FlowApproveNode.vue?vue&type=style&index=0&id=4b1a2c54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a2c54",
  null
  
)

export default component.exports